export default "__VITE_ASSET__Dh9cM8fy__";